/**
 * Created by lihanying on 2017/6/23.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import HomeView from './component/home'

class Home extends React.Component {
  static defaultProps = {
    clubList: [],
  }

  componentDidMount() {
    this.props.fetchClubList(this.updateClub)
  }

  updateClub = () => {
    this.forceUpdate()
    console.log('updated')
  }

  render() {
    const { clubList } = this.props
    return <HomeView clubList={clubList} />
  }
}

const mapStateToProps = (state) => {
  return {
    clubList: state.getHome.clubList,
  }
}
export default withRouter(connect(mapStateToProps, actions)(Home))



// WEBPACK FOOTER //
// ./src/containers/Home/index.js